// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"9094f6d3","683":"de87f1db","721":"e01c5c47","722":"e01c5c47","771":"0e1915eb"}[chunkId] + ".chunk.css";
};